import {AUTH} from 'src/shared/auth/actions';
import {token} from 'src/shared/auth/selectors';
import {currentBillSummary} from 'src/shared/config/urls';
import {createFetchResourceAction} from 'src/shared/utils/resource';

export const READ_CURRENT_BILL_SUMMARY_START = 'READ_CURRENT_BILL_SUMMARY_START';
export const READ_CURRENT_BILL_SUMMARY_SUCCESS = 'READ_CURRENT_BILL_SUMMARY_SUCCESS';
export const READ_CURRENT_BILL_SUMMARY_ERROR = 'READ_CURRENT_BILL_SUMMARY_ERROR';
export const READ_CURRENT_BILL_SUMMARY_COMPLETE = 'READ_CURRENT_BILL_SUMMARY_COMPLETE';

export const readCurrentBillSummary = () => createFetchResourceAction({
  start: READ_CURRENT_BILL_SUMMARY_START,
  success: READ_CURRENT_BILL_SUMMARY_SUCCESS,
  error: READ_CURRENT_BILL_SUMMARY_ERROR,
  complete: READ_CURRENT_BILL_SUMMARY_COMPLETE,
  waitUntil: AUTH,
  url: currentBillSummary,
  token,
});
